import axios from "axios";
import { linkUrl } from "../utilies/linkUrl";

const appointmentService = async () => {
    const res = await axios.get(`${linkUrl}/appo-detail`);
    if (res.data.status === 200) {
        return res.data.data[0];
    }
}

export default appointmentService;